document.addEventListener('DOMContentLoaded', function () {
    const joinRequestTitle = document.querySelector('.join-request__title');
    const header = document.querySelector('.header');

    if (!joinRequestTitle || !header) {
        return;
    }

    let resizeFrame = null;

    const keepTitleBelowHeader = function () {
        if (resizeFrame !== null) {
            window.cancelAnimationFrame(resizeFrame);
        }

        resizeFrame = window.requestAnimationFrame(() => {
            resizeFrame = window.requestAnimationFrame(() => {
                resizeFrame = null;

                if (document.body.classList.contains('no-scroll')) {
                    return;
                }

                const headerRect = header.getBoundingClientRect();
                const titleRect = joinRequestTitle.getBoundingClientRect();
                const titleIsCovered = titleRect.top < headerRect.bottom
                    && titleRect.bottom > headerRect.bottom;

                if (!titleIsCovered) {
                    return;
                }

                window.scrollTo({
                    top: Math.max(0, window.scrollY + titleRect.top - headerRect.bottom - 40),
                    behavior: 'auto'
                });
            });
        });
    };

    window.addEventListener('resize', keepTitleBelowHeader);
});
